import { render } from "./Skeleton.vue?vue&type=template&id=6798f5fc&ts=true"
import script from "./Skeleton.ts?vue&type=script&lang=ts&external"
export * from "./Skeleton.ts?vue&type=script&lang=ts&external"

import "./Skeleton.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__